module.exports = __webpack_public_path__ + "static/media/insight_desc3.8f1d2983.png";